class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form         = this.querySelector('[data-add-form]');
    this.variantInput = this.querySelector('[data-variant-input]');
    this.addBtn       = this.querySelector('[data-add-btn]');
    this.addLabel     = this.querySelector('[data-add-label]');
    this.priceMain    = this.querySelector('[data-price-main]');
    this.stockCount   = this.querySelector('[data-stock-count]');
    this.editionBtns  = [...this.querySelectorAll('.variant-option')];
    this.ausfBtns     = [...this.querySelectorAll('.ausf-option')];
    this.defaultLabel = this.addLabel ? this.addLabel.textContent : 'Add to Setup';

    const dataEl = this.querySelector('[data-variant-data]');
    this.variants = dataEl ? JSON.parse(dataEl.textContent) : [];

    // Initialzustand aus aktiver Auswahl ableiten
    const active = this.variants.find(v => v.id == this.variantInput.value) || this.variants[0];
    this.sel1 = active ? active.option1 : null;
    this.sel2 = active ? active.option2 : null;

    this.editionBtns.forEach(btn => btn.addEventListener('click', () => {
      if (btn.classList.contains('sold-out')) return;
      this.sel1 = btn.dataset.edition;
      this.recompute();
    }));
    this.ausfBtns.forEach(btn => btn.addEventListener('click', () => {
      if (btn.classList.contains('sold-out')) return;
      this.sel2 = btn.dataset.ausf;
      this.recompute();
    }));

// Externe Auswahl (Sticky-Bar) → Product-Form spiegeln, beide Achsen
    document.addEventListener('onyx:external-select', e => {
      const d = e.detail || {};
      if (d.source === 'product') return;           // eigenes Echo ignorieren
      let changed = false;
      if (d.edition != null && d.edition !== this.sel1) { this.sel1 = d.edition; changed = true; }
      if (d.ausf    != null && d.ausf    !== this.sel2) { this.sel2 = d.ausf;    changed = true; }
      if (changed) this.recompute();
    });

    // Pegel-Preview: Modell auf die Rückseite drehen
    const preview = this.querySelector('[data-pegel-preview]');
    if (preview) preview.addEventListener('click', () => this.showPegel());

    if (this.form) this.form.addEventListener('submit', e => this.addToCart(e));

    this.recompute(); // korrigiert Deltas/Preise beim Laden
  }

  findVariant(o1, o2) {
    return this.variants.find(v =>
      v.option1 === o1 && (o2 == null || v.option2 === o2)
    );
  }

  recompute() {
    const variant = this.findVariant(this.sel1, this.sel2) || this.findVariant(this.sel1, null);
    if (!variant) return;

    // Hidden-Input + Preis
    this.variantInput.value = variant.id;
    this.priceMain.textContent = this.formatMoney(variant.price);

    // Edition-Karten
    this.editionBtns.forEach(b => {
      const on = b.dataset.edition === this.sel1;
      b.classList.toggle('active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    // Ausführung-Toggle: aktiv + Verfügbarkeit + Delta je aktueller Edition
    if (this.ausfBtns.length) {
      const base = this.findVariant(this.sel1, this.ausfBtns[0].dataset.ausf);
      this.ausfBtns.forEach(b => {
        const combo = this.findVariant(this.sel1, b.dataset.ausf);
        const on = b.dataset.ausf === this.sel2;
        b.classList.toggle('active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.classList.toggle('sold-out', !combo || !combo.available);
        b.toggleAttribute('disabled', !combo || !combo.available);

        const deltaEl = b.querySelector('[data-ausf-delta]');
        if (deltaEl && combo && base) {
          const d = combo.price - base.price;
          deltaEl.textContent = d > 0 ? '+ ' + this.formatMoney(d) : '';
        }
      });
    }

    // Button-Status
    if (variant.available) {
      this.addBtn.disabled = false;
      this.addLabel.textContent = this.defaultLabel;
    } else {
      this.addBtn.disabled = true;
      this.addLabel.textContent = 'Ausverkauft';
    }

    // Stock-Urgency aktualisieren
    if (this.stockCount && variant.inventory_quantity != null) {
      this.stockCount.textContent = variant.inventory_quantity;
    }

    // Product-Form → Sticky-Bar
    document.dispatchEvent(new CustomEvent('onyx:variant-changed', {
      detail: { id: variant.id, edition: this.sel1, ausf: this.sel2,
                price: variant.price, available: variant.available }
    }));
  }

showPegel() {
    const root = document.querySelector('[data-onyx-viewer="product"]');
    if (!root) return;
    const go = v => v.showBack();
    if (root.onyxViewer) go(root.onyxViewer);
    else root.addEventListener('onyx:viewer-ready', e => go(e.detail), { once: true });
    if (window.matchMedia('(max-width: 899px)').matches) {
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  async addToCart(e) {
    e.preventDefault();
    this.addBtn.disabled = true;
    this.addLabel.textContent = '…';
    try {
      await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: this.variantInput.value, quantity: 1 }] }),
      });
      const cart = await (await fetch('/cart.js')).json();
      document.dispatchEvent(new CustomEvent('onyx:cart-updated', { detail: { count: cart.item_count } }));
      this.addLabel.textContent = '✓ Added';
      const next = this.querySelector('[data-added-next]');
      if (next) next.hidden = false;
      setTimeout(() => { this.addLabel.textContent = this.defaultLabel; this.addBtn.disabled = false; }, 1500);
    } catch (err) {
      console.error(err);
      this.addLabel.textContent = 'Fehler – nochmal';
      this.addBtn.disabled = false;
    }
  }

  formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, window.moneyFormat);
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
}
customElements.define('product-form', ProductForm);